import React from 'react'
import './WelcomeMessage.css'

const WelcomeMessage = () => {
  return (
    <div className="welcome-message">
      <p className="welcome-message__title">
        A long time ago in a galaxy far, far away ...
      </p>
    </div>
  )
}

export default WelcomeMessage
